// api2 signals "this action needs a stronger auth" as a 403 — the RFC 9470 challenge, body-encoded.
// This is the single coupling point to that wire format. TWO shapes exist (pass the whole parsed body):
//   • events dictionary (current): { event_id: "INSUFFICIENT_SCOPE", details: { scope: "<scope> [..]" } }
//     — emitted by middleware/auth.ts requireScope → throwEvent(Events.INSUFFICIENT_SCOPE, { scope }).
//   • legacy string (older/app):   { error: "insufficient_scope: <scope> [<scope> ...]" }
// A challenge may name MORE THAN ONE scope (AND-merged per-endpoint config); return them all,
// space-joined, so one OTP can mint a token satisfying every one.
export function parseInsufficientScope(body: unknown): string | null {
  const join = (raw: string): string | null => {
    const scopes = raw.trim().split(/\s+/).filter(Boolean);
    return scopes.length ? scopes.join(" ") : null;
  };
  const fromLegacy = (s: string): string | null => {
    const m = /^insufficient_scope:\s*(.+)$/.exec(s);
    return m ? join(m[1]) : null;
  };
  if (body && typeof body === "object") {
    const b = body as { event_id?: unknown; details?: { scope?: unknown }; error?: unknown };
    // Current: the coded INSUFFICIENT_SCOPE event carries the missing scope(s) in details.scope.
    if (b.event_id === "INSUFFICIENT_SCOPE" && b.details && typeof b.details.scope === "string") return join(b.details.scope);
    // Legacy: { error: "insufficient_scope: <scope> ..." }.
    if (typeof b.error === "string") return fromLegacy(b.error);
    return null;
  }
  if (typeof body === "string") return fromLegacy(body);
  return null;
}
